import React from "react";
import { createPortal } from "react-dom";
import Image from "gatsby-image";
import "./index.css";

const Share = ({ children, isOpen, onClose }) => {
  if (typeof document === `undefined`) return null;
  return isOpen
    ? createPortal(
        <div className="share-modal-main">
          <div className="share-container-modal">
            <p>Link copied✌️</p>
          </div>
        </div>,
        document.getElementById("portal")
      )
    : null;
};

export default Share;
